<template>
  <default-dialog v-model="form" @agree="createBlock" @cancel="form = {}">
    <template v-slot:card>
      <v-card-text>
        <types-list :list="blockTypes" @input="form.type = $event || {}" />
      </v-card-text>
    </template>

    <template v-slot:title>
      <v-toolbar-title>
        <strong>{{ $t('PLANNINGS.TASKS.BLOCK.TIME') }}</strong>
      </v-toolbar-title>
    </template>
  </default-dialog>
</template>

<script>
import TypesList from '@/modules/_global/_components/TypesList.vue';
import DefaultDialog from '@/modules/_global/_components/DefaultDialog.vue';
import formEditable from '@/modules/_global/mixins/form-editable';
import blockTypes from '@/modules/booking_schedule/mixins/block-types';

export default {
  name: 'BlockTypesDialog',

  components: {
    DefaultDialog,
    TypesList
  },

  mixins: [formEditable, blockTypes],

  data() {
    return {
      form: {}
    };
  },

  methods: {
    createBlock() {
      this.$emit('createBlock', this.form.type);
    }
  }
};
</script>
